/* Navigation enhancement only: all links and forms work without JavaScript. */
document.addEventListener('click', function (event) {
  document.querySelectorAll('.ac-mobile-menu[open], .ac-dropdown[open]').forEach(function (menu) {
    if (!menu.contains(event.target) || event.target.closest('a')) menu.removeAttribute('open');
  });
});
document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.ac-mobile-menu[open], .ac-dropdown[open]').forEach(function (menu) {
    menu.removeAttribute('open'); menu.querySelector('summary').focus();
  });
});
document.addEventListener('click', function (event) {
  const link = event.target.closest('[data-ac-product]');
  if (!link) return;
  const title = link.getAttribute('data-ac-product');
  const field = document.querySelector('[data-ac-inquiry-product]');
  if (field) { field.value = title; field.dispatchEvent(new Event('input', { bubbles: true })); }
  else { try { sessionStorage.setItem('ancooly-inquiry-product', title); } catch (_) {} }
});
try {
  const title = sessionStorage.getItem('ancooly-inquiry-product');
  const field = document.querySelector('[data-ac-inquiry-product]');
  if (title && field && !field.value) { field.value = title; sessionStorage.removeItem('ancooly-inquiry-product'); }
} catch (_) {}
